// 人机验证错误。
// class CaptchaError extends Error {
//   constructor(msg) {
//     super(msg)
//     if (Error.captureStackTrace) {
//       Error.captureStackTrace(this, CaptchaError)
//     }
//     this.name = '人机验证错误';
//   }
// }

const CaptchaErrorMap = {
  Board_Error: "您的修改画板频率过快，系统判断您可能是机器人。",
  Login_Error: "您的登录频率过快，系统判断您可能是机器人。",
  Login_Error_Msg:
    "您登录的频率过快，系统判断您可能是机器人。完成以下验证，可以继续进行相关操作。",
  Register_Error: "您的手机注册频率过快，系统判断您可能是机器人。",
  Register_Error_Msg:
    "您注册的频率过快，系统判断您可能是机器人。完成以下验证，可以继续进行相关操作。",
  Update_Error: "您的修改个人信息过快，系统判断您可能是机器人。",
  Default_Error:
    "您操作的频率过快，系统判断您可能是机器人。完成以下验证，可以继续进行相关操作",
};

function getCaptchaError(msg) {
  if (
    CaptchaErrorMap.Update_Error === msg ||
    CaptchaErrorMap.Board_Error === msg
  ) {
    return CaptchaErrorMap.Default_Error;
  } else if (CaptchaErrorMap.Login_Error === msg) {
    return CaptchaErrorMap.Login_Error_Msg;
  }
  return CaptchaErrorMap.Default_Error;
}

export {
  // CaptchaError,
  CaptchaErrorMap,
  getCaptchaError,
};
